import { SVGProps, Ref, forwardRef } from 'react'
const SvgDashlane = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 19 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M18.97 7.719c0-.149-.15-.298-.361-.357l-2.533-.922c-.422-.179-.904.03-.904.327V17.25c0 .149.15.327.3.387l2.594.922c.392.149.905-.06.905-.387V7.719Zm-4.733-3.663c0-.15-.15-.298-.362-.358l-2.533-.922c-.422-.178-.904.03-.904.328v6.372c0 .15.15.328.3.388l2.594.922c.392.149.905-.06.905-.387V4.056Zm0 11.466c0-.149-.15-.297-.362-.357l-2.533-.922c-.422-.179-.904.03-.904.328v6.372c0 .149.15.327.3.387l2.594.922c.392.15.905-.06.905-.387v-6.343Zm-4.734 1.281c0-.149-.15-.298-.362-.357l-2.533-.923c-.424-.178-.904.03-.904.328v6.79c0 .15.15.328.301.388l2.593.922c.392.15.905-.06.905-.387v-6.76Zm0-15.458c0-.148-.15-.297-.362-.357L6.608.066c-.424-.179-.904.03-.904.328v6.79c0 .15.15.328.301.387l2.593.922c.392.15.905-.059.905-.387v-6.76Zm-4.733.269c0-.15-.15-.298-.362-.358L1.875.334C1.453.155.971.364.971.662v21.74c0 .15.15.328.301.387l2.593.923c.392.148.905-.06.905-.388V1.614Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgDashlane)
export default ForwardRef
